import { render, staticRenderFns } from "./AccountMenu.vue?vue&type=template&id=45b8280e&scoped=true&"
import script from "./AccountMenu.vue?vue&type=script&lang=js&"
export * from "./AccountMenu.vue?vue&type=script&lang=js&"
import style0 from "./AccountMenu.vue?vue&type=style&index=0&id=45b8280e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b8280e",
  null
  
)

export default component.exports